import { render, staticRenderFns } from "./RewardsBadge.vue?vue&type=template&id=f769b40a&"
import script from "./RewardsBadge.vue?vue&type=script&setup=true&lang=js&"
export * from "./RewardsBadge.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports